export default function(selector, context) {
    if (!context) {
        context = document;
    }
    return [].slice.call(context.querySelectorAll(selector));
}
